(function ($) {
    'use strict';

    $(document).ready(function () {
        console.log('[PWB Modal Debug] Script ready handler initialized');
        console.log('[PWB Modal Debug] woodmart_settings on load:', typeof woodmart_settings !== 'undefined' ? JSON.stringify(woodmart_settings) : 'undefined');
        console.log('[PWB Modal Debug] wc_add_to_cart_params on load:', typeof wc_add_to_cart_params !== 'undefined' ? JSON.stringify(wc_add_to_cart_params) : 'undefined');

        let pwb_added_to_cart = false;
        let modalOpen = false;
        let checkingCart = false;

        let originalAddToCartAction = 'widget';
        let originalCartRedirect = 'no';

        if (typeof woodmart_settings !== 'undefined') {
            originalAddToCartAction = woodmart_settings.add_to_cart_action;
            woodmart_settings.add_to_cart_action = 'none'; // Intercept theme's action
            console.log('[PWB Modal Debug] Intercepted woodmart_settings.add_to_cart_action. Original was:', originalAddToCartAction);

            if (woodmart_settings.cart_redirect_after_add) {
                originalCartRedirect = woodmart_settings.cart_redirect_after_add;
                woodmart_settings.cart_redirect_after_add = 'no'; // Intercept theme's redirect
                console.log('[PWB Modal Debug] Intercepted woodmart_settings.cart_redirect_after_add. Original was:', originalCartRedirect);
            }

            // Disable any auto-close timeouts in Woodmart
            woodmart_settings.add_to_cart_action_timeout = 'no';
        }
        if (typeof wc_add_to_cart_params !== 'undefined') {
            if (wc_add_to_cart_params.cart_redirect_after_add) {
                originalCartRedirect = wc_add_to_cart_params.cart_redirect_after_add;
                wc_add_to_cart_params.cart_redirect_after_add = 'no'; // Intercept WooCommerce's redirect
                console.log('[PWB Modal Debug] Intercepted wc_add_to_cart_params.cart_redirect_after_add. Original was:', originalCartRedirect);
            }
        }

        function triggerOriginalAction() {
            console.log('[PWB Modal Debug] triggerOriginalAction called. originalAddToCartAction:', originalAddToCartAction, 'originalCartRedirect:', originalCartRedirect);
            if (originalAddToCartAction === 'redirect' || originalCartRedirect === 'yes') {
                let cartUrl = '';
                if (typeof woodmart_settings !== 'undefined' && woodmart_settings.cart_url) {
                    cartUrl = woodmart_settings.cart_url;
                } else if (typeof wc_add_to_cart_params !== 'undefined' && wc_add_to_cart_params.cart_url) {
                    cartUrl = wc_add_to_cart_params.cart_url;
                }
                console.log('[PWB Modal Debug] Redirecting to cart URL:', cartUrl);
                if (cartUrl) {
                    window.location.href = cartUrl;
                }
            } else if (originalAddToCartAction === 'widget') {
                console.log('[PWB Modal Debug] Opening cart widget side menu');
                $('.cart-widget-side').addClass('wd-opened');
                $('.woodmart-close-side').addClass('woodmart-close-side-opened');
                const $cartOpener = $('.cart-widget-opener');
                if ($cartOpener.length > 0) {
                    $cartOpener.first().trigger('click');
                }
            }
        }

        // Check for item added to cart.
        $('body').on('added_to_cart', function () {
            console.log('[PWB Modal Debug] intercepted added_to_cart event. pwb_added_to_cart:', pwb_added_to_cart, 'modalOpen:', modalOpen, 'checkingCart:', checkingCart);
            if (pwb_added_to_cart == false && modalOpen == false && checkingCart == false) {
                checkPrayerBeadsAndShowModal();
            }
            pwb_added_to_cart = false;
        });

        // Function to check for prayer beads and show the modal.
        function checkPrayerBeadsAndShowModal() {
            console.log('[PWB Modal Debug] Starting check_prayer_beads_in_cart AJAX check');
            checkingCart = true;
            $.ajax({
                url: prayer_video_data.ajax_url,
                type: 'POST',
                data: {
                    action: 'check_prayer_beads_in_cart',
                    nonce: prayer_video_data.modal_content_nonce,
                },
                success: function (response) {
                    checkingCart = false;
                    console.log('[PWB Modal Debug] check_prayer_beads_in_cart AJAX success. Response:', response);
                    if (response.data.has_prayer_beads && response.data.has_subscription == false) {
                        console.log('[PWB Modal Debug] User qualifies for modal. Showing modal');
                        showPrayerVideoModal(response.data.modal_content);
                    } else {
                        console.log('[PWB Modal Debug] User does not qualify for modal.');
                        triggerOriginalAction();
                    }
                },
                error: function (error) {
                    checkingCart = false;
                    console.error('[PWB Modal Debug] Error checking beads in cart:', error);
                    triggerOriginalAction();
                }
            });
        }

        // Function to display the Vanilla JS overlay modal.
        function showPrayerVideoModal(modalContent) {
            console.log('[PWB Modal Debug] showPrayerVideoModal (Vanilla JS) called');
            modalOpen = true;

            // Create Overlay
            const overlay = document.createElement('div');
            overlay.id = 'pwb-offer-modal-overlay';
            overlay.style.cssText = 'position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.6); z-index: 999999; display: flex; align-items: center; justify-content: center; opacity: 0; transition: opacity 0.3s ease;';

            // Create Modal Content Wrapper
            const modalBox = document.createElement('div');
            modalBox.id = 'pwb-offer-modal-box';
            modalBox.style.cssText = 'background: #fff; padding: 25px; border-radius: 8px; width: 90%; max-width: 500px; box-shadow: 0 4px 15px rgba(0,0,0,0.2); transform: scale(0.9); transition: transform 0.3s ease; position: relative; font-family: sans-serif; box-sizing: border-box;';

            // Create Title
            const modalTitle = document.createElement('h3');
            modalTitle.innerText = 'Special Offer!';
            modalTitle.style.cssText = 'margin-top: 0; margin-bottom: 15px; font-size: 22px; font-weight: bold; text-align: center; color: #333;';
            modalBox.appendChild(modalTitle);

            // Create Close 'x' button
            const closeX = document.createElement('button');
            closeX.innerHTML = '&times;';
            closeX.style.cssText = 'position: absolute; top: 10px; right: 15px; font-size: 24px; color: #aaa; cursor: pointer; border: none; background: none; outline: none; padding: 0; line-height: 1;';
            closeX.onclick = function() {
                console.log('[PWB Modal Debug] Close "x" clicked');
                closeModal();
            };
            modalBox.appendChild(closeX);

            // Append template content
            const contentDiv = document.createElement('div');
            contentDiv.innerHTML = modalContent;
            modalBox.appendChild(contentDiv);

            overlay.appendChild(modalBox);
            document.body.appendChild(overlay);

            // Trigger Animations
            setTimeout(() => {
                overlay.style.opacity = '1';
                modalBox.style.transform = 'scale(1)';
            }, 50);

            // Close Side Cart to prevent overlap
            const closeSideCart = () => {
                console.log('[PWB Modal Debug] closing side cart to prevent overlap');
                $('.cart-widget-side').removeClass('wd-opened');
                $('.woodmart-close-side').removeClass('woodmart-close-side-opened');
            };
            closeSideCart();
            setTimeout(closeSideCart, 250);
            setTimeout(closeSideCart, 500);
            setTimeout(closeSideCart, 1000);

            // Bind events inside the injected content
            const addToCartButton = $(modalBox).find('.add-to-cart-button');
            addToCartButton.on('click', function () {
                const productId = $(this).data('product_id');
                console.log('[PWB Modal Debug] ADD TO CART clicked inside modal for product:', productId);
                addToCart(productId);
            });

            const modalCloseButton = $(modalBox).find('.close-modal-button');
            modalCloseButton.on('click', function () {
                console.log('[PWB Modal Debug] NO THANKS clicked inside modal');
                closeModal();
            });
        }

        // Function to add a product to the cart (using WooCommerce AJAX).
        function addToCart(productId) {
            const addToCartButton = $('#pwb-offer-modal-overlay .add-to-cart-button');
            addToCartButton.addClass('loading');
            addToCartButton.attr('disabled', true);

            $.ajax({
                url: wc_add_to_cart_params.ajax_url,
                type: 'POST',
                data: {
                    action: 'woocommerce_add_to_cart',
                    product_id: productId,
                    quantity: 1
                },
                success: function (response) {
                    if (response.error && response.product_url) {
                        window.location = response.product_url;
                        return;
                    } else {
                        console.log('[PWB Modal Debug] Add to cart AJAX success. Closing modal.');
                        pwb_added_to_cart = true;
                        $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, addToCartButton]);
                        closeModal(); // Close the modal after adding to cart
                    }
                },
                error: function (error) {
                    console.error('[PWB Modal Debug] Error adding to cart:', error);
                },
            });
        }

        function closeModal() {
            console.log('[PWB Modal Debug] closeModal called');
            const overlay = document.getElementById('pwb-offer-modal-overlay');
            if (overlay) {
                const modalBox = document.getElementById('pwb-offer-modal-box');
                overlay.style.opacity = '0';
                if (modalBox) {
                    modalBox.style.transform = 'scale(0.9)';
                }
                setTimeout(() => {
                    overlay.remove();
                    console.log('[PWB Modal Debug] Modal overlay removed from DOM');
                    triggerOriginalAction();
                }, 300);
            }
            modalOpen = false;
        }

        // Check if we need to show the modal on page load (for POST form fallbacks)
        if (typeof prayer_video_data !== 'undefined' && prayer_video_data.show_modal_on_load) {
            console.log('[PWB Modal Debug] show_modal_on_load is true. Triggering modal on page load.');
            showPrayerVideoModal(prayer_video_data.modal_content);
        }

        $(window).on('beforeunload', function() {
            console.log('[PWB Modal Debug] beforeunload event triggered on window');
        });
        $(window).on('unload', function() {
            console.log('[PWB Modal Debug] unload event triggered on window');
        });
    });
})(jQuery);